{
  "seo": {
    "title": "For Parents — Safe Learning for Curious Kids",
    "description": "CuriPop gives parents peace of mind with safe, ad-free, expert-reviewed content. Track progress, manage profiles, and set reading levels.",
    "keywords": "safe learning app for kids, parent dashboard, kids educational content, age-appropriate answers"
  },
  "hero": {
    "tagline": "Designed with parents in mind",
    "titlePrefix": "Safe Learning for",
    "titleHighlight": "Curious Kids",
    "subtitle": "Give your children a safe, ad-free space to explore the answers to their biggest questions. You stay in control.",
    "primaryCta": "Start Free",
    "secondaryCta": "Preview Content"
  },
  "trust": {
    "items": ["COPPA Compliant", "No Data Sharing", "No Ads", "Parent Dashboard"]
  },
  "features": {
    "items": [
      {
        "title": "AI-Curated Content",
        "description": "Every question and answer is carefully crafted and reviewed to be accurate, age-appropriate, and educational."
      },
      {
        "title": "Safe & Ad-Free",
        "description": "No advertisements, no external links, no user-generated content. Just pure learning in a safe environment."
      },
      {
        "title": "Daily Discovery",
        "description": "Free accounts get a fresh set of 12 questions each day, with optional unlimited access for families who want more."
      },
      {
        "title": "Progress Tracking",
        "description": "See what your child is learning about, track their quiz scores, and celebrate their curiosity."
      },
      {
        "title": "Multiple Child Profiles",
        "description": "Create separate profiles for each child with their grade and reading-level settings."
      },
      {
        "title": "Growing Library",
        "description": "1,000+ fascinating questions covering science, nature, space, history, and more — always expanding."
      }
    ]
  },
  "sections": {
    "features": {
      "title": "Why Parents Choose Curipop",
      "subtitle": "We built Curipop with parents like you in mind—because we're parents too."
    }
  },
  "steps": {
    "titlePrefix": "Get Started in",
    "titleHighlight": "3 Easy Steps",
    "items": [
      {
        "title": "Create Your Account",
        "description": "Sign in with Google or another provider. Quick, secure, no forms to fill."
      },
      {
        "title": "Add Child Profiles",
        "description": "Create profiles for each of your children with their name and grade."
      },
      {
        "title": "Start Exploring",
        "description": "Your kids can start learning immediately. You can track everything from your dashboard."
      }
    ]
  },
  "faq": {
    "tagline": "Frequently Asked Questions",
    "title": "Questions Parents Ask",
    "items": [
      {
        "question": "What age is Curipop designed for?",
        "answer": "Curipop is designed for children ages 4-12. Our content is written to be understandable for younger children while remaining interesting for older ones. Parents can set each child's grade and optional reading level for context."
      },
      {
        "question": "How do I create a child account?",
        "answer": "Sign in with Google (or another enabled provider) to create child profiles from your Parent Dashboard. Each child gets their own profile with their name, grade, and avatar. Children access the app using a simple family access code—no email required."
      },
      {
        "question": "Is my child's data safe?",
        "answer": "Absolutely. We are COPPA-compliant and take children's privacy seriously. We don't collect any personal information from children beyond what's needed for the app to function. Children's learning data is only visible to their parent/guardian."
      },
      {
        "question": "Can I control what my child sees?",
        "answer": "Yes! From the Parent Dashboard, you can manage child profiles, adjust reading levels, and review activity history. All our content is pre-screened to be child-safe."
      },
      {
        "question": "How does the free plan work?",
        "answer": "Free accounts get 12 hand-picked questions every day from our classic discovery set — the selection rotates daily so there's always something new. Upgrade to the Family plan for instant, unlimited access to every question."
      },
      {
        "question": "Can I cancel my subscription anytime?",
        "answer": "Yes, you can cancel your subscription at any time from your account settings. You'll continue to have access until the end of your billing period."
      }
    ]
  },
  "cta": {
    "title": "Ready to Spark Their Curiosity?",
    "subtitle": "Join thousands of families who trust Curipop for safe, educational content.",
    "primary": "Start Free",
    "secondary": "Compare Plans"
  }
}
